var map = {
	"./album.svg": "az2L",
	"./assessmentList.svg": "g34+",
	"./auth.svg": "TnCw",
	"./certify.svg": "O76m",
	"./comment.svg": "A+6H",
	"./copy.svg": "Gbaw",
	"./decline-operate.svg": "0mRF",
	"./decline.svg": "xIhW",
	"./delete.svg": "WaGb",
	"./download.svg": "Ta63",
	"./edit.svg": "qkZ8",
	"./empty_praise.svg": "/bbk",
	"./external.svg": "URq1",
	"./eye.svg": "TfVu",
	"./forbidden.svg": "2ImH",
	"./giveup.svg": "xBec",
	"./klassCircle.svg": "1wgO",
	"./klassTask.svg": "558f",
	"./leftRotate.svg": "ToZN",
	"./logout.svg": "AXUd",
	"./menu.svg": "vT3+",
	"./notice.svg": "/Jmp",
	"./pass-operate.svg": "qSX9",
	"./pass.svg": "mt5s",
	"./pencil.svg": "BcQf",
	"./photo.svg": "ZTJu",
	"./plus.svg": "Ls6J",
	"./praise.svg": "1YXS",
	"./publish.svg": "mPNK",
	"./publish_icon.svg": "Vo/F",
	"./redo.svg": "GLqH",
	"./reset.svg": "m0vK",
	"./revoke.svg": "vO5E",
	"./rightRotate.svg": "dsv0",
	"./school.svg": "wDN7",
	"./sensitive.svg": "YY+N",
	"./top.svg": "3u49",
	"./user.svg": "s7Vf",
	"./videoIcon.svg": "zJFc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";